import { Field } from "formik"
import { cn } from "../../../lib/utils"

const TextField = ({ name, placeholder, type = "text", className, error, ...props }) => {
  return (
    <Field
      type={type}
      name={name}
      placeholder={placeholder}
      className={cn(
        "mt-2 block w-full rounded-lg border-gray-300 shadow-sm",
        error
          ? "border-2 border-red-500 ring-red-500 focus:border-red-700 focus:ring-red-700"
          : "focus:border-brandSecondary focus:ring-brandSecondary",
        className,
      )}
      {...props}
    />
  )
}

export default TextField
